import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Button,
    CircularProgress,
    colors,
    Modal, Box
} from '@material-ui/core';

import { PageContext } from '../PageContext';
import { UserContext } from '../../../contexts/UserContext';

import { ApplicationRoles } from '../../../../helpers';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import ClearIcon from '@material-ui/icons/Clear';
import PublishIcon from '@material-ui/icons/Publish';
import GetAppIcon from '@material-ui/icons/GetApp';

import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    button: {
        marginRight: theme.spacing(1)
    },
    deleteButton: {
        color: theme.palette.getContrastText(colors.red[500]),
        backgroundColor: colors.red[500],
        '&:hover': {
            backgroundColor: colors.red[700],
        }
    },
    buttonShow: {
        display: "inline-flex"
    },
    buttonHide: {
        display: "none"
    },
    progress: {
        color: "white"
    },
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        backgroundColor: '#ffffff'
    },
    modalTitle: {
        backgroundColor: '#f5f2f0',
        fontSize: '25px',
        padding: '20px'
    },
    modalText: {
        fontSize: '15px',
        padding: '20px'
    },
    modalButton: {
        width: '140px'
    },
    buttonsContainer: {
        padding: '0 20px 20px 20px',
        textAlign: 'center'
    },
    buttonContinue: {
        backgroundColor: '#c2a07b'
    },
    buttonClose: {
        marginRight: '25px'
    }
}));

const ExcelButton = withStyles((theme) => ({
    root: {
        color: "#FFF",
        backgroundColor: colors.green[500],
        '&:hover': {
            backgroundColor: colors.green[700],
        },
    },
}))(Button);

export const Toolbar = ({
    disabled,
    onAddNewRow,
    onDeleteRow,
    onSave,
    onCancel,
    onResetGrid,
    onImportRows,
    onExportRows,
    onShowHelp,
    getSelectedNodes,
    ...props }) => {
    const classes = useStyles();

    const {
        isUserInRole,
        isUserInRoles
    } = useContext(UserContext);

    const {
        state,
        isBusy,
        setIsBusy,
        deleteAllFilteredRows
    } = useContext(PageContext);

    const {
        table,
        dataTransaction,
        gridState
    } = state;

    const [showModal, setShowModal] = useState(false);

    const addNewRowClickHandler = (e) => {
        if (onAddNewRow) onAddNewRow();
    }

    const deleteRowClickHandler = (e) => {
        if (onDeleteRow) onDeleteRow();
    }

    const saveClickHandler = (e) => {
        if (onSave) onSave();
    }

    const cancelClickHandler = (e) => {
        if (onCancel) onCancel();
    }

    const clearFiltersClickHandler = (e) => {
        if (onResetGrid) onResetGrid();
    }

    const importRowsClickHandler = (e) => {
        if (onImportRows) onImportRows();
    }

    const exportRowsClickHandler = (e) => {
        if (onExportRows) onExportRows();

    }

    const showHelpClickHandler = (e) => {
        if (onShowHelp) onShowHelp();
    }

    const [actions, setActions] = useState({
        canAdd: true,
        canDelete: true,
        canSave: false,
        canCancel: false,
        canResetGrid: false
    });

    // useEffect(() => {
    // }, [state.selectedRowsCount]);

    useEffect(() => {
        setActions({
            canAdd: true,//!dataTransaction.hasPendingChanges,
            canDelete: true,//!dataTransaction.hasPendingChanges || dataTransaction.changes.find(x => x.changeType === DataChangeType.AddNew) === undefined,
            canSave: dataTransaction ? dataTransaction.hasPendingChanges : false,
            canCancel: dataTransaction ? dataTransaction.hasPendingChanges : false,
            canResetGrid: gridState !== null
        });
    }, [dataTransaction, gridState]);

    // useEffect(() => {
    // }, [state.filterModel]);

    return (
        <Grid container className={clsx(classes.root, props.className)} justifyContent="space-between">
            <Grid item>
                <Button
                    variant="contained"
                    color="secondary"
                    className={clsx(classes.button, state.filterModel && Object.keys(state.filterModel).length !== 0 ? classes.buttonShow : classes.buttonHide)}
                    disabled={disabled || !actions.canResetGrid || isBusy("_savingGridState")}
                    onClick={clearFiltersClickHandler}>
                    {isBusy("_savingGridState") ?
                        <><CircularProgress size={20} className={classes.progress} />&nbsp;&nbsp;Saving Filters</>
                        :
                        <><ClearIcon />&nbsp;Clear Filters</>
                    }
                </Button>
                {isUserInRoles([ApplicationRoles.Administrator, ApplicationRoles.Editor]) &&
                    <>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            startIcon={<AddIcon />}
                            disabled={disabled || !actions.canAdd}
                            onClick={addNewRowClickHandler}>
                            Add Row
                        </Button>
                        <Button
                            variant="contained"
                            color="default"
                            className={clsx(classes.button, classes.deleteButton, state.selectedRowsCount > 0 ? classes.buttonShow : classes.buttonHide)}
                            startIcon={<DeleteIcon />}
                            disabled={disabled || !actions.canDelete}
                            onClick={deleteRowClickHandler}>
                            Delete
                        </Button>
                        <Button
                            variant="contained"
                            color="default"
                            className={clsx(classes.button, classes.deleteButton, state.filterModel && Object.keys(state.filterModel).length !== 0 && state.rowsInPage > 0 ? classes.buttonShow : classes.buttonHide)}
                            startIcon={<DeleteIcon />}
                            disabled={disabled || !actions.canDelete}
                            onClick={(e) => { 
                                setIsBusy({ deleting: true });
                                setShowModal(!showModal); 
                            }}>
                            Delete all filtered
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            startIcon={<SaveIcon />}
                            disabled={disabled || !actions.canSave}
                            onClick={saveClickHandler}>
                            Save
                        </Button>
                        {actions.canCancel &&
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                                startIcon={<ClearIcon />}
                                disabled={disabled}
                                onClick={cancelClickHandler}>
                                Cancel
                            </Button>
                        }
                    </>
                }
            </Grid>
            <Grid item>
                {isUserInRoles([ApplicationRoles.Administrator, ApplicationRoles.Editor]) &&
                    <>
                        {table.allowImport &&
                            <ExcelButton
                                variant="contained"
                                className={classes.button}
                                startIcon={<PublishIcon />}
                                disabled={disabled}
                                onClick={importRowsClickHandler}>
                                Import
                            </ExcelButton>
                        }
                    </>
                }
                {isUserInRoles([ApplicationRoles.Administrator, ApplicationRoles.Editor, ApplicationRoles.Viewer]) &&
                    <>
                        <ExcelButton
                            variant="contained"
                            className={classes.button}
                            startIcon={<GetAppIcon />}
                            disabled={disabled}
                            onClick={exportRowsClickHandler}>
                            Export
                        </ExcelButton>
                    </>
                }
                <Button
                    variant="contained"
                    color="secondary"
                    className={classes.button}
                    disabled={disabled || isBusy("_savingGridState")}
                    onClick={showHelpClickHandler}>
                    Help
                </Button>
                <Modal open={ showModal }>
                    <Box className={ classes.modal }>
                        <div className={ classes.modalTitle }>
                            Delete all filtered items
                        </div>
                        <div className={ classes.modalText }>
                            This action will delete all the filtered items. Are you sure you want to continue?
                        </div>
                        <div className={ classes.buttonsContainer }>
                            <Button className={ clsx(classes.button, classes.deleteButton, classes.modalButton, classes.buttonClose) } onClick={ () => { setShowModal(!showModal); setIsBusy({ deleting: false }); } }><ClearIcon />&nbsp;Close</Button>
                            <Button startIcon={<SaveIcon />} className={ clsx(classes.button, classes.modalButton, classes.buttonContinue) } onClick={ () => {
                                deleteAllFilteredRows(table.managedTableId); 
                                setShowModal(!showModal);
                            } }>Continue</Button>
                        </div>
                    </Box>
                </Modal>
            </Grid>
        </Grid >
    );
}